import { DeleteButton } from '../../../components/DeleteButton';
import { EditButton } from '../../../components/EditButton';

import css from './IqMessengerConnection.module.scss';

export const IqMessengerConnection = ({ connection, handleDelete, handleEdit }) => {

    return (
        <tr>
            <td>
                <div className={css.flexContainer}>
                    <div>
                        {connection.name}
                    </div>
                </div>
            </td>
            <td>
                <div className={css.flexContainer}>
                    <div>
                        {connection.clientId}
                    </div>
                </div>
            </td>
            <td className="align-middle">
                <DeleteButton className="float-right mr-1" tooltip="Delete" onClick={() => handleDelete(connection)} />
                <EditButton className="float-right mr-1" tooltip="Edit" onClick={() => handleEdit(connection)} />                
            </td>
        </tr>
    )
}